<style lang="less" scoped>
  .order-product-wrapper {
    min-height: 100vh;
    padding: 30rpx;
    .no-more {
      text-align: center;
      line-height: 2em;
      font-size: 14px;
      color: #999;
      box-sizing: border-box;
    }
    .order-product-item {
      padding: 30rpx 18rpx 40rpx 30rpx;
      margin-bottom: 20rpx;
      background: #fff;
      border-radius: 20rpx;
    }
    .item-above {
      display: flex;
      align-items: flex-start;
    }
    .item-picture {
      width: 160rpx;
      height: 160rpx;
      margin-right: 18rpx;
      border-radius: 10rpx;
    }
    .item-describe {
      flex: 1;
      overflow: hidden;
    }
    .item-name {
      max-height: 3em;
      margin-bottom: 18rpx;
      font-size: 0.875rem;
      color: #333;
      line-height: 1.5;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .item-spec {
      min-height: 1.5em;
      font-size: 0.875rem;
      color: #999;
      line-height: 1.5;
    }
    .item-under {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 10rpx;
    }
    .item-under-btn {
      height: 50rpx;
      padding: 0 20rpx;
      margin-left: 20rpx;
      background: #fff;
      border: 0;
      outline: 0;
      box-shadow: inset 0 0 0 1px #999;
      border-radius: 50rpx;
      color: #999;
      transition: color 0.2s ease, box-shadow 0.2s ease;
      cursor: pointer;
      &:active {
        color: #333;
        box-shadow: inset 0 0 0 1px #333;
      }
      &.red-style {
        color: @DefaultColor;
        box-shadow: inset 0 0 0 1px @DefaultColor;
        &:active {
          opacity: 0.6;
        }
      }
    }
  }
</style>
<template>
  <van-pull-refresh v-model="loading"
                    @refresh="onRefresh"
                    class="order-product-wrapper">
    <div v-for="(item, index) in orderDtl.storeOrderDtls"
         :key="index"
         class="order-product-item">
      <div class="item-above"
           @click="warranty(item)">
        <!-- 成品，优先取规格图其次选取主图最后默认图 -->
        <template v-if="item.product.productType === 1">
          <img v-if="item.product.productSkuList[0].imgPath"
               class="item-picture"
               :src="item.product.productSkuList[0].imgPath">
          <img v-else-if="item.product.mainImg"
               class="item-picture"
               :src="item.product.mainImg">
          <img v-else
               class="item-picture"
               src="~@/assets/default_product.png">
        </template>
        <!-- 定制，优先取主图其次取默认图 -->
        <template v-else>
          <img v-if="item.product.mainImg"
               class="item-picture"
               :src="item.product.mainImg">
          <img v-else
               class="item-picture"
               src="~@/assets/default_product.png">
        </template>
        <div class="item-describe">
          <div class="item-name">{{ item.product.name }}</div>
          <div v-if="item.product.productSkuList[0].hasProperty && sysConstConfig.showSpecName === 'yes'"
               class="item-spec"
               v-html="skuFormat(item.product)"></div>
          <div v-if="sysConstConfig.showBuyPrice === 'orderPrice'"
               class="item-spec"
               style="color: #ff5859;">¥{{ item.orderPrice || 0 }}</div>
          <div v-if="sysConstConfig.showBuyPrice === 'realPrice'"
               class="item-spec"
               style="color: #ff5859;">¥{{ item.realPrice || 0 }}</div>
          <div v-if="item.productRuleBind"
               class="item-spec"
               v-html="specFormat(item)"></div>
        </div>
      </div>
      <!-- <div v-if="orderDtl.storeOrderEvaluateBase" -->
      <div class="item-under">
        <button v-if="item.productRuleBind && item.productRuleBind.productRule.enableInsurance"
                class="item-under-btn"
                @click="applyFn('/insurance', item)">申请膜险</button>
        <button v-if="item.haveQa"
                class="item-under-btn red-style"
                @click="applyFn('/after-sale', item)">申请售后</button>
      </div>
    </div>

    <div class="no-more">没有更多了~</div>
    <div class="safe-area-bottom"></div>
  </van-pull-refresh>
</template>
<script>
  import { queryOrderWarranty } from '@/config/api.js'

  export default {
    name: 'WarrantyProducts',
    data () {
      return {
        loading: false,
        tenantId: '',
        orderCode: '',
        orderId: '',
        orderDtl: {}
      }
    },
    methods: {
      skuFormat (data) {
        if (!data) { return '-' }
        /*
          成品 规格
          定制 子商品名：规格
              子商品名：规格
        **/
        let _result = []
        if (data.productType === 1) {
          if (data.productSkuList[0].hasProperty === 1) {
            data.productSkuList[0].propertyBindList.forEach(element => {
              const _spec = element.productPropertyDtlBindList[0].productPropertyDtl.name
              _result.push(_spec)
            })
            return _result.join('、')
          } else {
            return '无规格'
          }
        } else {
          if (data.childProductList) {
            data.childProductList.forEach(element => {
              if (element.productSkuList[0].hasProperty === 1) {
                const _spec = []
                element.productSkuList[0].propertyBindList.forEach(item => {
                  _spec.push(item.productPropertyDtlBindList[0].productPropertyDtl.name)
                })
                _result.push(`${element.name}：${_spec.join('、')}`)
              } else {
                _result.push(`${element.name}：无规格`)
              }
            })
          } else {
            return '无规格'
          }
        }
        return _result.join('<br>')
      },
      specFormat (data) {
        if (!data || !data.productRuleBind) { return '' }
        const result = []
        data.productRuleBind.productRule.productRuleNodeList.forEach(nodeItem => {
          nodeItem.productRuleElementList.forEach(elementItem => {
            if (elementItem.productRuleElementValueBindList && Number(elementItem.productRuleElementValueBindList[0].value || 0)) {
              result.push(elementItem.label)
            }
          })
        })

        return result.join('+')
      },
      onRefresh () {
        this.loading = true
        queryOrderWarranty({
          keywords: this.orderCode,
          tenantId: this.tenantId
        }).then(res => {
          this.loading = false
          if (res.success) {
            const list = res.result || []
            list.forEach(item => {
              if (item.id === this.orderId) {
                this.orderDtl = item
              }
            })
          }
        })
      },
      warranty (data) {
        // if (!this.orderDtl.storeOrderEvaluateBase) {
        //   this.$toast('请对订单评价后再来')
        //   return false
        // }
        if (!data.haveQa) {
          this.$toast('该商品没有质保信息')
          return false
        }
        this.$router.push({
          path: '/warranty-detail',
          query: {
            usr: this.tenantId,
            type: data.product.productType,
            dtl: data.id
          }
        })
      },
      applyFn (type, data) {
        this.$router.push({
          path: type,
          query: {
            usr: this.tenantId,
            dtl: data.id
          }
        })
      }
    },
    mounted () {
      this.tenantId = this.$route.query.usr || ''
      this.orderCode = this.$route.query.key || ''
      this.orderId = this.$route.query.id || ''
      this.onRefresh()
    }
  }
</script>